define('taoQtiItem/qtiCreator/widgets/choices/states/Active',['taoQtiItem/qtiCreator/widgets/states/factory', 'taoQtiItem/qtiCreator/widgets/states/Active'], function(stateFactory, Active){
    
    var ChoiceStateActive = stateFactory.create(Active, function(){
        
    },function(){
        
    });

    return ChoiceStateActive;
});
